export default __webpack_public_path__ + "media/images/dashboard_icons/savethedates-2918772051cc277b2d8e9b8d921acd08.svg";